import React, { useEffect, useState } from "react";
import { auth, database } from "../firebaseConfig";
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";
import { ref, onValue } from "firebase/database";
import AdminViewer from "./AdminViewer";

export default function AdminLogin() {
  const [user, setUser] = useState(null);
  const [data, setData] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // ascolta cambiamenti stato auth
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      setUser(u);
    });
    return () => unsubscribe();
  }, []);

  // carica dati dal DB quando loggato
  useEffect(() => {
    if (!user) return;

    const dbRef = ref(database, "/");
    const unsubscribe = onValue(dbRef, (snapshot) => {
      setData(snapshot.val() || {});
    });

    return () => unsubscribe();
  }, [user]);

  // login
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setError("");
    } catch (err) {
      setError("Errore login: " + err.message);
    }
  };

  // logout
  const handleLogout = async () => {
    await signOut(auth);
    setData(null);
  };

  // se non loggato → mostra form login
  if (!user) {
    return (
      <div style={styles.loginBox}>
        <h2>Login Amministratore</h2>
        <form onSubmit={handleLogin} style={styles.form}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
          <button type="submit" style={styles.button}>Login</button>
        </form>
        {error && <div style={styles.error}>{error}</div>}
      </div>
    );
  }

  // se loggato → mostra AdminViewer
  return (
    <div>
      <div style={styles.topBar}>
        <span>Sei loggato come {user.email}</span>
        <button onClick={handleLogout} style={styles.button}>Logout</button>
      </div>
      <AdminViewer data={data} />
    </div>
  );
}

// Styles semplici inline
const styles = {
  loginBox: {
    maxWidth: 400,
    margin: "80px auto",
    padding: 20,
    border: "1px solid #ccc",
    borderRadius: 8,
    background: "#fff",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  input: {
    padding: 8,
    borderRadius: 4,
    border: "1px solid #ccc",
  },
  button: {
    padding: 8,
    borderRadius: 4,
    border: "none",
    background: "#2563eb",
    color: "#fff",
    cursor: "pointer",
  },
  error: {
    marginTop: 10,
    color: "red",
  },
  topBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 12,
    background: "#f3f4f6",
    borderBottom: "1px solid #ccc",
  },
};
